import BaseModel from '../../../model/BaseModel';
import Temperature from '../../../model/Temperature';
import Feature from '../../../strategy/Feature';

export default class MockTemperature implements Feature {
  execute(): BaseModel {
    const min = Math.ceil(35);
    const max = Math.floor(40);

    const newValue = Math.floor(Math.random() * (max - min)) + min;
    const intValue = Math.floor(Math.random() * (max - min)) + min;
    const doubleValue = 0;

    return new Temperature(newValue, intValue, doubleValue);
  }
}
